import { faPlay } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dropdown } from 'antd';
import React, { useEffect, useState } from 'react';
import { getRandomColor } from '../../../../utils';
import { styles } from '../styles';

const DropdownEditData = ({ index, type, editorInfo, onUpdate, handleOpenChange, isPieOrPolarChart }) => {
  const classes = styles();

  const [items, setItems] = useState([]);

  const addDataAboveIndex = (array, index, data) => {
    return [...array.slice(0, index), data, ...array.slice(index)];
  };

  const addDataBelowIndex = (array, index, data) => {
    return [...array.slice(0, index + 1), data, ...array.slice(index + 1)];
  };

  const handleEditRow = (data, type) => {
    const { categories, series, theme } = data;

    const res = {
      categories,
      series,
    };

    if (res.series.length === 1 && type === 'delete') return;

    const newSeries = {
      name: 'Untitled' + (series.length + 1),
      color: getRandomColor(),
      data: Array(categories.length).fill(0),
    };

    if (theme?.length > 0) {
      const colorIndex = series.length % theme.length;
      newSeries.color = theme[colorIndex];
    }

    switch (type) {
      case 'above':
        res.series = addDataAboveIndex(res.series, index, newSeries);
        break;
      case 'below':
        res.series = addDataBelowIndex(res.series, index, newSeries);
        break;
      default:
        res.series.splice(index, 1);
        break;
    }

    handleOpenChange(false);
    onUpdate(res);
  };

  const handleEditCol = (type) => {
    const { categories, series } = JSON.parse(editorInfo.data);

    const data = {
      categories,
      series,
    };

    if (data.categories.length === 1 && type === 'delete') return;

    const newCategories = 'Untitled' + (categories.length + 1);

    switch (type) {
      case 'left':
        data.categories = addDataAboveIndex(data.categories, index, newCategories);
        data.series = data.series.map((item) => {
          return {
            ...item,
            data: addDataAboveIndex(item.data, index, 0),
          };
        });
        break;
      case 'right':
        data.categories = addDataBelowIndex(data.categories, index, newCategories);
        data.series = data.series.map((item) => {
          return {
            ...item,
            data: addDataBelowIndex(item.data, index, 0),
          };
        });
        break;
      default:
        data.categories.splice(index, 1);
        data.series = data.series.map((item) => {
          item.data.splice(index, 1);
          return item;
        });
        break;
    }

    handleOpenChange(false);
    onUpdate(data);
  };

  const handleSelectColRender = () => {
    const data = JSON.parse(editorInfo.data);
    data.selectedColumn = index;
    handleOpenChange(false);
    onUpdate(data);
  };

  const getRowItems = (data) => {
    const rowItems = [
      {
        key: '1',
        label: <span onClick={() => handleEditRow(data, 'delete')}>Delete Row</span>,
        disabled: data && data.series.length === 1,
      },
      {
        key: '2',
        label: <span onClick={() => handleEditRow(data, 'above')}>Insert Row Above</span>,
      },
      {
        key: '3',
        label: <span onClick={() => handleEditRow(data, 'below')}>Insert Row Below</span>,
      },
    ];

    return rowItems;
  };

  const getColItems = (data) => {
    const colItems = [
      {
        key: '1',
        label: <span onClick={() => handleEditCol('delete')}>Delete Column</span>,
        disabled: data && data.categories.length === 1,
      },
      {
        key: '2',
        label: <span onClick={() => handleEditCol('right')}>Insert Column Right</span>,
      },
      {
        key: '3',
        label: <span onClick={() => handleEditCol('left')}>Insert Column Left</span>,
      },
      {
        key: '4',
        label: <span onClick={() => handleSelectColRender()}>Select This Column</span>,
      },
    ];

    if (!isPieOrPolarChart) {
      colItems.pop();
    }

    return colItems;
  };

  useEffect(() => {
    if (editorInfo.data) {
      const data = JSON.parse(editorInfo.data);
      switch (type) {
        case 'col':
          setItems(getColItems(data));
          break;
        default:
          setItems(getRowItems(data));
          break;
      }
    }
  }, [type, editorInfo.data]);

  return (
    <Dropdown
      menu={{ items }}
      overlayClassName={classes.dropdown}
      placement="topRight"
      trigger={'click'}
      onOpenChange={handleOpenChange}
    >
      <div className={classes.editButton}>
        <FontAwesomeIcon icon={faPlay} rotation={90} />
      </div>
    </Dropdown>
  );
};

export default DropdownEditData;
